NtechApp.ChatServices = function() {
    var me = this;

    this._ajax = null;
    this._click = null;

    this._isSavingAllRead = false;
    this._originalAllReadText = "";

    this._construct = function() {
        me._ajax = new NtechApp.Ajax();
        me._click = new NtechApp.TouchClickEvent();

        me._bindEvents();
    }

    this._bindEvents = function() {

    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.proto(NtechApp.ChatServices, {
    _getMarkAllReadRoute: function() {
        if(NtechApp.clientSettings.isPersonal)
            return 'personal_chat_mark_all_read';
        else if(NtechApp.clientSettings.isBusiness)
            return 'business_chat_mark_all_read';
    },

    saveMarkAllRead: function($item) {
        var me = this;

        if(this._isSavingAllRead)
            return;

        this._isSavingAllRead = true;
        this._originalAllReadText = $item.text();

        $item.text("");
        this._ajax.enableTextLoading($item);

        me._ajax.post({
            url: Routing.generate(me._getMarkAllReadRoute()),
            onSuccess: function(data) {
                if(!data.wereChatsViewed)
                    return;

                $(window).trigger(NtechApp.WINDOW_EVENTS.EVENT_MARK_ALL_READ);
            },
            onComplete: function() {
                $item.text(me._originalAllReadText);

                me._isSavingAllRead = false;
                me._ajax.disableTextLoading($item);
            }
        });
    }
});